/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * AI provider options
 */
export enum AiProvider {
    /**
     * Azure OpenAI provider
     */
    Azure = 1,
}
